export enum QrCodeType {
  CHECKIN_REASON = 'CHECKIN_REASON',
  ID = 'ID',
  FLEX_TIME_ACTIVITY = 'FLEX_TIME_ACTIVITY',
  WEBSITE_URL = 'WEBSITE_URL',
}
